import { render, staticRenderFns } from "./EventProduct.vue?vue&type=template&id=7fbc221a&"
import script from "./EventProduct.vue?vue&type=script&lang=js&"
export * from "./EventProduct.vue?vue&type=script&lang=js&"
import style0 from "./EventProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports